import HistoricalFundsBalanceError from './HistoricalFundsBalanceError';
class BalancePropertyIsNotRegistered extends HistoricalFundsBalanceError {
    propertyId;
    constructor(propertyId, options) {
        super('Property ID not registered for historical balance', options);
        this.propertyId = propertyId;
    }
}
export default BalancePropertyIsNotRegistered;
